import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page10() {
  useEffect(() => {
    document.title = "Маяк — Страница 9"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page8" />
        <ForwardLink href="/page10" />
      </div>

      <p style={{ textAlign: "right" }}>9.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Какой-то салага, с которым я вожусь--<br/>
        Ты ведешь себя так, будто никогда не был в море<br/>
        раньше.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я...
      </p>
      <p>
        МОЛОДОЙ колеблется, он не был в море прежде -- очевидно. <i>Но<br/>
        не стоит вдаваться в это сейчас.</i>
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Да, сэр.
      </p>
      <p>Старик смотрит на него с отвращением.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Эта униформа не подходит тебе.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Ну, сэр, это форма, которую мне<br/>
        мне выдали в профсоюзе--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Я имею в виду, что ты не готов<br/>
        ее носить. Выполняй свои обязанности.<br/>
        <u>Свет</u> <u>мой</u>.
      </p>
      <p>ПРОПУЩЕНО</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – НОЧЬ</p>
      <p>
        ЧРЕЗВЫЧАЙНО ШИРОКИЙ ПЛАН: вспышки МАЯКА. ФОГОРН<br/>
        ревет.
      </p>
      <br/>
      <p>ВНУТРИ. ЗДАНИЕ ФОГОРНА – НОЧЬ</p>
      <br/>
      <p>МОЛОДОЙ закидывает больше угля в печь. ЗЛИТСЯ!</p>
      <p>
        Он бросает злобный взгляд на КНИГУ, лежащую на стуле<br/>
        рядом с горячим, жужжащим механизмом: <b><i>«Инструкции Хранителям Маяка,<br/>
        июль 1881 года.»</i></b> Он проклинает руководство:
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Сукин-сын.
      </p>
      <p>ФОГОРН РЕВЕТ.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        СУКИН-СЫН!
      </p>
      <p style={{ textAlign: "right" }}>9.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page8" />
        <ForwardLink href="/page10" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1707874633/the-lighthouse-script/hzhqib4xoko4m9izc0q2.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page10;
